export const AQQAR_URL_PARAM = "aqqarRedirected";
export const AQQAR_SOURCE_ID = "32";
export const DEFAULT_SOURCE_ID = "1";
export const AQQAR_MAX_LOAN_AMOUNT = 266000;
